/**
 * KAN-897: подтверждение "Не успех" (отказ) в приложении менеджера; общее для
 * блока "Итог" карточки клиента и кнопки "Отработано" в "Мои лиды".
 */
import { cn } from '@/lib/utils';

const BTN = 'min-h-[48px] rounded-xl px-4 text-base font-medium disabled:opacity-50';

interface MobileRefuseConfirmProps {
  onConfirm: () => void;
  onCancel: () => void;
  className?: string;
}

export function MobileRefuseConfirm({ onConfirm, onCancel, className }: MobileRefuseConfirmProps): JSX.Element {
  return (
    <div className={cn('space-y-2 rounded-lg bg-red-50 p-3', className)} role="alertdialog" aria-label="Подтверждение отказа">
      <p className="text-sm text-red-800">Отметить отказ? Бот перестанет писать клиенту.</p>
      <div className="grid grid-cols-2 gap-2">
        <button type="button" onClick={onConfirm} className={cn(BTN, 'bg-red-600 text-white')}>
          Да, отказ
        </button>
        <button type="button" onClick={onCancel} className={cn(BTN, 'border border-gray-300 bg-white text-gray-900')}>
          Нет
        </button>
      </div>
    </div>
  );
}
